const Style = {
  breadcrumbs: 'overflow-auto mb-2',
  link: `float-left m0 cursor-pointer no-underline 
    hover:text-brand-violet/80 after:content-['_/'] after:mx-2 text-brand-violet after:text-slate-300
    last:after:content-['']`,
}

export default Style
